import { render } from "./LabelCategoryGroup.vue?vue&type=template&id=7a78cc6f&ts=true"
import script from "./LabelCategoryGroup.vue?vue&type=script&lang=ts"
export * from "./LabelCategoryGroup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QList from 'quasar/src/components/item/QList.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QItemSection,QIcon,QBadge,QList});
